export const Modes = {
  add: 'add',
  edit: 'edit',
};
